/**
 * @module lib/lazy-images
 */
import lazyConfig from "panther/lazysizes-config";
import lazySizes from "lazysizes";

// Share lazySizes config.
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.init = false;
Object.keys(lazyConfig).map(key => {
  window.lazySizesConfig[key] = lazyConfig[key];
});

/**
 * @method init
 * @description Delay initialization
 * https://github.com/aFarkas/lazysizes#lazysizesinit
 */
export default function init() {
  lazySizes.init();
}
